import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NewsletterModule } from '@shared/newsletter/newsletter.component';
import { PartnersLogosModule } from '@shared/partners-logos/partners-logos.component';
import { PopularCategoriesModule } from '@shared/popular-categories/popular-categories.module';
import { QuoteBlockModule } from '@shared/quote-block/quote-block.component';
import { SearchInputModule } from '@shared/search-input/search-input.component';
import { StatsBlockModule } from '@shared/stats-block/stats-block.component';
import { TestimonialsModule } from '@shared/testimonials/testimonials.component';
import { TextBlockModule } from '@shared/text-block/text-block.component';
import { ExploreGridModule } from '../../shared/explore-grid/explore-grid.component';
import { ImgBlockModule } from '../../shared/img-block/img-block.component';
import { PartnersModule } from '../../shared/partners/partners.component';
import { PopularGridModule } from '../../shared/popular-grid/popular-grid.module';
import { HomeHeroComponent } from './home-hero/home-hero.component';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
  imports: [
    HomeRoutingModule,
    ImgBlockModule,
    ExploreGridModule,
    PartnersModule,
    PopularGridModule,
    ReactiveFormsModule,
    SearchInputModule,
    PopularCategoriesModule,
    TextBlockModule,
    QuoteBlockModule,
    StatsBlockModule,
    TestimonialsModule,
    PartnersLogosModule,
    NewsletterModule,
    HomeHeroComponent,
    HomeComponent,
  ],
})
export class HomeModule {}
